import moment from "moment";
import { parseDateModifier as dateRuleParser } from "../../forms/helper";

const findMaxDate = (params: any) => {
    const {
        only_date_in_past: onlyDateInPast,
        field_boi_date_in_past: fieldBoiDateInPast,
        include_today_in_dates: includeToday,
        field_boi_date_in_today_or_past: fieldBoiDateInTodayOrPast,
        max_date: maxDate,
        max_date_rule: maxDateRule,
        field_boi_max_date_rule: fieldBoiMaxDateRule,
        field_boi_max_end_date_rule: fieldBoiMaxEndDateRule,
        field_boi_max_date_range_rule: fieldBoiMaxDateRangeRule,
        field_boi_minimum_age: fieldBoiMinAge
    } = params;
    const limits = [];
    const today = moment().startOf("day");

    onlyDateInPast &&
        limits.push(today.clone().add(includeToday ? 0 : -1, "days"));

    fieldBoiDateInPast && limits.push(today.clone().add(-1, "days"));
    fieldBoiDateInTodayOrPast && limits.push(today);

    maxDate && limits.push(moment(maxDate, "DD/MM/YYYY"));

    if (maxDateRule) {
        const duration = moment.duration(dateRuleParser(maxDateRule));
        const max = today.clone().add(duration);

        limits.push(max);
    }

    if (fieldBoiMaxDateRule) {
        const duration = moment.duration(dateRuleParser(fieldBoiMaxDateRule));
        const max = today.clone().add(duration);

        limits.push(max);
    }

    if (fieldBoiMaxEndDateRule) {
        const duration = moment.duration(
            dateRuleParser(fieldBoiMaxEndDateRule)
        );
        const max = today.clone().add(duration);

        limits.push(max);
    }

    if (
        fieldBoiMaxDateRangeRule &&
        ((params.type === "boi_date_range" && params.value) ||
            params.type !== "boi_date_range")
    ) {
        const startDate = params.inputs
            ? moment(params.value[params.inputs[0].id], "YYYY-MM-DD")
            : today.clone();
        const duration = moment.duration(
            dateRuleParser(fieldBoiMaxDateRangeRule)
        );
        const max = startDate
            .clone()
            .add(duration)
            .add(params.inputs ? -1 : 0, "days");

        max.isValid() && limits.push(max);
    }

    fieldBoiMinAge &&
        limits.push(today.clone().add(-parseInt(fieldBoiMinAge), "years"));

    return limits.length ? moment.min(limits).toDate() : null;
};

export default findMaxDate;
